export const defaultAuthState = {
	userInfo: {},
	tokenType: null,
	mtaxAccessToken: null,
	mTaxExpire: null,
	expiredDate: null,
	misaAccessToken: null,
	misaExpire: null,
	misaRefreshToken: null,
	EmailActive: false,
	PhoneActive: false,
	isLater: false,
	timeOut: 0,
	LinkSignalR: null,
	RunSignalR: false,
	//Cờ chọn kênh thông báo real-time (nguồn: MWSSettings.IsMWSEnabled — BE trả qua MtaxData.RunMWS khi login)
	//ON → chỉ kết nối MWS; OFF → chỉ kết nối SignalR (loại trừ tuyệt đối)
	IsMWSEnabled: false,
	isShowWarningLisence: false,
	isRequiredLicense: true,
	sessionExchanged: false,
	amisAuthData: {}
};

export default {
	...defaultAuthState
};
